import posthog, { type PostHog } from 'posthog-js';
import { readImpersonationOrigin } from '@/pages/super-admin/impersonation/impersonation.helpers';

type AnalyticsAction = (client: PostHog) => void;

export const runAnalytics = (action: AnalyticsAction): void => {
	if (posthog.__loaded !== true) return;
	try {
		action(posthog);
	} catch {
		// Analytics never breaks the app.
	}
};

export const registerBaseProperties = (client: PostHog): void => {
	client.register({ environment: import.meta.env.VITE_APP_ENV, platform: 'web' });
};

export const isImpersonating = (): boolean => readImpersonationOrigin() !== null;

export const resumeCapturingAfterStaleImpersonation = (client: PostHog): void => {
	if (!client.has_opted_out_capturing()) return;
	client.opt_in_capturing({ captureEventName: false });
};

export const resetAnalytics = (): void =>
	runAnalytics((client) => {
		client.reset();
		registerBaseProperties(client);
	});

export const pauseAnalyticsForImpersonation = (): void =>
	runAnalytics((client) => {
		if (client.has_opted_out_capturing()) return;
		client.opt_out_capturing();
	});

export const startImpersonationAnalytics = (): void =>
	runAnalytics((client) => {
		client.reset();
		client.opt_out_capturing();
	});

export const endImpersonationAnalytics = (): void =>
	runAnalytics((client) => {
		client.reset();
		client.opt_in_capturing({ captureEventName: false });
		registerBaseProperties(client);
	});
